export const getCategoriesPagesCols = (isXL, isLG) => {
  if (isXL) {
    return 4;
  }
  if (isLG) {
    return 3;
  }
  return 2;
};
